/* Structure:
<Card>
  <CardHeader>
    <CardTitle></CardTitle>
  </CardHeader>
  <CardContent></CardContent>
</Card>
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { card, collapsibleCard, collapsibleContent, collapsibleHeader, collapsibleTitle, footer, header, headerLink, subHeader, title, content, contentSubHeader, actionArea, } from '../styles/legacy';
import { card as cardCitrus2022, collapsibleCard as collapsibleCardCitrus2022, collapsibleContent as collapsibleContentCitrus2022, collapsibleHeader as collapsibleHeaderCitrus2022, collapsibleTitle as collapsibleTitleCitrus2022, footer as footerCitrus2022, header as headerCitrus2022, headerLink as headerLinkCitrus2022, subHeader as subHeaderCitrus2022, title as titleCitrus2022, content as contentCitrus2022, contentSubHeader as contentSubHeaderCitrus2022, actionArea as actionAreaCitrus2022, } from '../styles/citron';
import { citrusStyled } from '@citrus/runtime';
export var Card = citrusStyled.div('card', { legacy: card, citrus2022: cardCitrus2022 });
export var CollapsibleCard = citrusStyled.div('collapsibleCard', {
    legacy: collapsibleCard,
    citrus2022: collapsibleCardCitrus2022,
});
export var Footer = citrusStyled.div('footer', { legacy: footer, citrus2022: footerCitrus2022 });
export var Header = citrusStyled.div('header', { legacy: header, citrus2022: headerCitrus2022 });
export var CollapsibleHeader = citrusStyled.div('collapsibleHeader', {
    legacy: collapsibleHeader,
    citrus2022: collapsibleHeaderCitrus2022,
});
export var HeaderLink = citrusStyled.a('headerLink', { legacy: headerLink, citrus2022: headerLinkCitrus2022 });
export var SubHeader = citrusStyled.div('subHeader', { legacy: subHeader, citrus2022: subHeaderCitrus2022 });
export var Title = citrusStyled.h3('title', { legacy: title, citrus2022: titleCitrus2022 });
export var CollapsibleTitle = citrusStyled.h3('collapsibleTitle', {
    legacy: collapsibleTitle,
    citrus2022: collapsibleTitleCitrus2022,
});
export var TitleAs = function (as) { return citrusStyled.as(as)('title', title); };
export var Content = citrusStyled.div('N/A', null);
export var ContentPadding = citrusStyled.div('content', { legacy: content, citrus2022: contentCitrus2022 });
export var ContentPaddingWithSubHeader = citrusStyled.div('contentSubHeader', {
    legacy: contentSubHeader,
    citrus2022: contentSubHeaderCitrus2022,
});
export var CollapsibleContent = function (_a) {
    var children = _a.children, contentPadding = _a.contentPadding;
    var XContent = citrusStyled.div(contentPadding ? 'collapsibleContent' : 'N/A', contentPadding ? { legacy: __assign({}, collapsibleContent), citrus2022: __assign({}, collapsibleContentCitrus2022) } : null);
    return React.createElement(XContent, null, children);
};
export var ActionArea = citrusStyled.div('actionArea', { legacy: actionArea, citrus2022: actionAreaCitrus2022 });
export var Styled = {
    Card: Card,
    CollapsibleCard: CollapsibleCard,
    Footer: Footer,
    Header: Header,
    HeaderLink: HeaderLink,
    SubHeader: SubHeader,
    Title: Title,
    TitleAs: TitleAs,
    Content: Content,
    ContentPadding: ContentPadding,
    ContentPaddingWithSubHeader: ContentPaddingWithSubHeader,
    ActionArea: ActionArea,
};
